import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import '../../Foundations/PhotoOverlay/PhotoOverlay.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './Button.module.css.mjs';
import { buttonSizeClasses, buttonIconSizeClasses, buttonVariantClasses, buttonTypographySize } from './Button.utils.mjs';

const Button = polymorphicFactory(
  (props, ref) => {
    const {
      component = "button",
      children,
      fullWidth,
      size = "medium",
      leftSection,
      rightSection,
      disabled,
      variant = "primary",
      className,
      icon,
      hasHoverEffect = true,
      ...rest
    } = props;
    const classNames = clsx(
      classes.buttonRoot,
      "kohler-button-root",
      className,
      size && !icon ? buttonSizeClasses[size] : buttonIconSizeClasses[size],
      icon && classes.iconButton,
      fullWidth && classes.buttonFullWidth,
      variant && buttonVariantClasses[variant],
      hasHoverEffect && classes.buttonHover
    );
    const Icon = icon || void 0;
    return /* @__PURE__ */ React.createElement(
      Typography,
      {
        className: classNames,
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        disabled,
        size: buttonTypographySize[size],
        ...rest
      },
      leftSection && /* @__PURE__ */ React.createElement(Box, { component: "span", className: clsx("kohler-button-section", classes.sections) }, leftSection),
      /* @__PURE__ */ React.createElement(Box, { component: "span", className: classes.label }, Icon ? /* @__PURE__ */ React.createElement(Icon, { size: size === "small" ? "small" : "medium", withBoundingBox: true }) : children),
      rightSection && /* @__PURE__ */ React.createElement(Box, { component: "span", className: clsx("kohler-button-section", classes.sections) }, rightSection)
    );
  }
);

export { Button };
